import React, { FC } from 'react';
import RangePicker from '@sg/components/GeneralRangePicker';
export const RANGE_PICKER_TYPE = 'month';
export const RANGE_PICKER_TYPES = [RANGE_PICKER_TYPE];

const LiveMonthFilter: FC= ({ value, onChange, ...restProps }) => {
  return (
    <RangePicker
      style= {{ marginRight: 10 }}
      disabled={false}
      type={RANGE_PICKER_TYPE}
      typeList={RANGE_PICKER_TYPES}
      value={value}
      showShortcut={false}
      onChange={onChange}
      {...restProps}
    />
  );
};

export default LiveMonthFilter;
